import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "container-fluid mb-5",
  role: "region",
  "aria-label": "user subscription"
};
const _hoisted_2 = {
  class: "m-0 card-title text-center"
};
const _hoisted_3 = {
  class: "m-0 card-title text-center"
};
const _hoisted_4 = {
  key: 0
};
const _hoisted_5 = {
  key: 1
};
const _hoisted_6 = {
  key: 2
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Loading = _resolveComponent("Loading");
  const _component_b_icon = _resolveComponent("b-icon");
  const _component_PayBalance = _resolveComponent("PayBalance");
  const _component_b_card_header = _resolveComponent("b-card-header");
  const _component_Cancel = _resolveComponent("Cancel");
  const _component_Info = _resolveComponent("Info");
  const _component_b_card_text = _resolveComponent("b-card-text");
  const _component_b_card = _resolveComponent("b-card");
  const _component_Change = _resolveComponent("Change");
  const _component_SubscriptionTypeInfo = _resolveComponent("SubscriptionTypeInfo");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_Loading, {
    loading: _ctx.loading
  }, null, 8, ["loading"]), !_ctx.loading && $options.balanceDue > 0 ? (_openBlock(), _createBlock(_component_PayBalance, {
    key: 0,
    subscription: _ctx.subscription,
    states: _ctx.states,
    countries: _ctx.countries,
    onRefresh: $options.init
  }, {
    default: _withCtx(() => [_createElementVNode("h2", null, [_createVNode(_component_b_icon, {
      icon: "exclamation-circle-fill"
    }), _createTextVNode(" Your Account Has an Unpaid Balance of " + _toDisplayString(_ctx.accountStatus.localbalance.localcurrencyformatted), 1)]), _cache[0] || (_cache[0] = _createElementVNode("p", null, "You will be prohibited from access to videos and live streams until this balance is paid.", -1))], undefined, true),
    _: 1
  }, 8, ["subscription", "states", "countries", "onRefresh"])) : _createCommentVNode("", true), !_ctx.loading && _ctx.accountStatus && $options.isCurrent ? (_openBlock(), _createBlock(_component_b_card, {
    key: 1,
    class: "mb-3",
    "no-body": ""
  }, {
    default: _withCtx(() => [_createVNode(_component_b_card_header, null, {
      default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createElementVNode("h4", {
        class: "m-0 card-title text-center"
      }, "Current Subscription", -1)]))], undefined, true),
      _: 1
    }), _createVNode(_component_b_card_text, {
      class: "m-3"
    }, {
      default: _withCtx(() => [_createVNode(_component_Info, {
        subscription: _ctx.subscription,
        class: _normalizeClass(_ctx.subscription.nextsubscriptiontype_id > 0 ? 'alert alert-danger' : ''),
        onRefresh: $options.init
      }, {
        default: _withCtx(() => [_createVNode(_component_Cancel, {
          subscription: _ctx.subscription,
          onRefresh: $options.init
        }, null, 8, ["subscription", "onRefresh"])], undefined, true),
        _: 1
      }, 8, ["subscription", "class", "onRefresh"])], undefined, true),
      _: 1
    })], undefined, true),
    _: 1
  })) : _createCommentVNode("", true), !_ctx.loading && _ctx.accountStatus && _ctx.accountStatus.balance <= 0 && $options.filteredTypes.length > 0 && (!_ctx.subscription || !_ctx.subscription.nextsubscriptiontype_id) && !_ctx.isAdmin ? (_openBlock(), _createBlock(_component_b_card, {
    key: 2,
    "no-body": ""
  }, {
    default: _withCtx(() => [_createVNode(_component_b_card_header, null, {
      default: _withCtx(() => [_createElementVNode("h4", _hoisted_2, _toDisplayString($options.isCurrent ? 'Change' : 'Choose') + " your Subscription", 1)], undefined, true),
      _: 1
    }), _createVNode(_component_b_card_text, {
      class: "m-3"
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.filteredTypes, t => {
        return _openBlock(), _createBlock(_component_b_card, {
          key: t.id,
          class: "mb-3"
        }, {
          default: _withCtx(() => [_createVNode(_component_b_card_text, null, {
            default: _withCtx(() => [_createVNode(_component_SubscriptionTypeInfo, {
              subscriptiontype: t,
              onRefresh: $options.init
            }, {
              default: _withCtx(() => [_createVNode(_component_Change, {
                subscription: _ctx.subscription,
                subscriptiontype: t,
                status: _ctx.accountStatus,
                types: _ctx.types,
                states: _ctx.states,
                countries: _ctx.countries,
                onRefresh: $options.init
              }, null, 8, ["subscription", "subscriptiontype", "status", "types", "states", "countries", "onRefresh"])], undefined, true),
              _: 2
            }, 1032, ["subscriptiontype", "onRefresh"])], undefined, true),
            _: 2
          }, 1024)], undefined, true),
          _: 2
        }, 1024);
      }), 128))], undefined, true),
      _: 1
    })], undefined, true),
    _: 1
  })) : _createCommentVNode("", true), !_ctx.loading && !(_ctx.accountStatus && _ctx.accountStatus.balance <= 0 && $options.filteredTypes.length > 0 && (!_ctx.subscription || !_ctx.subscription.nextsubscriptiontype_id) && !_ctx.isAdmin) ? (_openBlock(), _createBlock(_component_b_card, {
    key: 3,
    "no-body": ""
  }, {
    default: _withCtx(() => [_createVNode(_component_b_card_header, null, {
      default: _withCtx(() => [_createElementVNode("h4", _hoisted_3, _toDisplayString(_ctx.isAdmin ? 'No data to display' : 'Subscription Options'), 1)], undefined, true),
      _: 1
    }), _createVNode(_component_b_card_text, {
      class: "m-3 text-center"
    }, {
      default: _withCtx(() => [_ctx.isAdmin ? (_openBlock(), _createElementBlock("h3", _hoisted_4, "As an administrator you do not need to have a subscription")) : _ctx.subscription && _ctx.subscription.nextsubscriptiontype_id > 0 ? (_openBlock(), _createElementBlock("h3", _hoisted_5, " Your next renewal is already scheduled. Your plan will change on " + _toDisplayString(_ctx.subscription.enddate) + " and no action is needed. ", 1)) : (_openBlock(), _createElementBlock("h3", _hoisted_6, "No subscription options are available at this time."))], undefined, true),
      _: 1
    })], undefined, true),
    _: 1
  })) : _createCommentVNode("", true)]);
}